import { useRenderPinnedFilters } from '@aibees/elephant/feature/more-filters/hooks/use-render-pinned-filters';
import { usePinnedFiltersSearchTerm } from '@aibees/elephant/feature/more-filters/context';
import { NoData } from '@aibees/shared/components';
import { useMaintainScrollForListOfAccordions } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { Box } from '@mui/material';
import { memo } from 'react';
import { ACCORDION_DATA_ATTRIBUTE_KEY } from '../../constants/config';
import { useSearchFiltersStore } from '../../store';
import { Filter } from '../filter/filter';
import * as SX from './sx';
import type { FilterListProps as Props } from './types';

export const FilterList = memo(({ className }: Props) => {
  const { filters, tagsByFilterName } = useRenderPinnedFilters();
  const { searchTableSearchTerm } = usePinnedFiltersSearchTerm();
  const current = useSearchFiltersStore.useCurrent();
  const containerRef = useMaintainScrollForListOfAccordions(
    ACCORDION_DATA_ATTRIBUTE_KEY as string,
    typeof current === 'string' ? current : undefined
  );

  const showNoResults = Boolean(searchTableSearchTerm && filters.length === 0);

  return (
    <Box
      ref={containerRef}
      className={classnames('FilterList', className)}
      sx={SX.container}
    >
      {showNoResults && (
        <Box sx={SX.emptyStateWrapper}>
          <NoData title="No Result Found" icon="filter-alt-outline" />
        </Box>
      )}
      {filters.map((filter) => (
        <Box
          key={`${filter.name}-${filter.index}`}
          sx={SX.filterBox(current === filter.name)}
        >
          <Filter
            filter={filter}
            tags={tagsByFilterName.get(filter.name) ?? undefined}
          />
        </Box>
      ))}
    </Box>
  );
});

FilterList.displayName = 'FilterList';
